import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.main`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ChatContainer = styled.div<{
  showCharacter: boolean;
  isChatLayoutShow: boolean;
}>`
  ${({ showCharacter, isChatLayoutShow, theme }) => css`
    display: ${isChatLayoutShow ? 'flex' : 'none'};
    position: absolute;
    bottom: 0;
    left: 0;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-top: ${theme.layout.chat_header_height};
    overflow: hidden;
    transition: height 0.1s ease-in-out;
  `}
`;

export const BackgroundContainer = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
